import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=39617a11&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=js&"
export * from "./Activities.vue?vue&type=script&lang=js&"
import style0 from "./Activities.vue?vue&type=style&index=0&id=39617a11&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39617a11",
  null
  
)

component.options.__file = "Activities.vue"
export default component.exports